.pageContainer {
  box-sizing: border-box;
  margin: 0 auto;
  padding-left: clamp(
    var(--hcr-spacing-2),
    3vw,
    var(--hcr-spacing-5)
  );
  padding-right: clamp(
    var(--hcr-spacing-2),
    3vw,
    var(--hcr-spacing-5)
  );
  width: 100%;
}
